import { Storefront } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { NodeEnv } from "@dzambalaorg/constants";
import { List } from "@dzambalaorg/ui-kit";

import { StyledPaper } from "../styled";

const data = [
  { text: "pages.dashboard.infrastructure.pages.about-us", link: "/pages/about-us", icon: <Storefront /> },
  { text: "pages.dashboard.infrastructure.pages.faq", link: "/pages/faq", icon: <Storefront /> },
  { text: "pages.dashboard.infrastructure.pages.privacy-policy", link: "/pages/privacy-policy", icon: <Storefront /> },
  {
    text: "pages.dashboard.infrastructure.pages.terms-of-services",
    link: "/pages/terms-of-services",
    icon: <Storefront />,
  },
];

export const PagesSection = () => {
  const isProd = process.env.NODE_ENV === NodeEnv.production;

  if (isProd) {
    return null;
  }

  return (
    <StyledPaper>
      <List
        component="nav"
        subheader={
          <List.Subheader>
            <FormattedMessage id="pages.dashboard.infrastructure.pages.title" />
          </List.Subheader>
        }
      >
        {data.map(({ text, icon, link }) => (
          <List.ItemButton<typeof RouterLink> key={text} component={RouterLink} to={link}>
            <List.ItemIcon>{icon}</List.ItemIcon>
            <List.ItemText>
              <FormattedMessage id={text} />
            </List.ItemText>
          </List.ItemButton>
        ))}
      </List>
    </StyledPaper>
  );
};
